import { DataSort } from '../../core/models/data-sort';

export const appointmentSort: DataSort = {
  id: 1,
  value: 'dateOfServiceUtc',
  display: 'Date of Service',
  isDefault: true,
};
